import { createCrudSlice } from './createCrudSlice';
import { tabletopsApi } from '../../services/api';

const { reducer, actions } = createCrudSlice('tabletops', tabletopsApi);

export const {
  fetchAll: fetchTabletops,
  fetchById: fetchTabletopById,
  create: createTabletop,
  update: updateTabletop,
  remove: deleteTabletop,
  clearError,
  clearCurrentItem,
} = actions;

export default reducer;
